import { Link } from 'react-router-dom';
import { ARENA_OWNER_SIGNUP, ROUTES } from 'shared/constants/routes';
import { BrandLogo } from 'shared/components/brand/BrandLogo';

export function Footer() {
  return (
    <footer className="border-t border-border/60 bg-surface">
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-4 py-8 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <BrandLogo size="sm" />
          <p className="mt-2 max-w-xs text-sm text-ink-secondary">
            A forma mais simples de reservar quadra, dividir o Pix e jogar com a galera.
          </p>
        </div>

        <div className="flex flex-wrap gap-x-10 gap-y-4 text-sm">
          <div className="flex flex-col gap-2">
            <span className="font-medium text-ink">Jogadores</span>
            <Link to={ROUTES.HOME} className="text-ink-secondary hover:text-primary">
              Buscar arenas
            </Link>
            <Link to={ROUTES.TOURNAMENTS} className="text-ink-secondary hover:text-primary">
              Torneios
            </Link>
            <Link to={ROUTES.SIGNUP} className="text-ink-secondary hover:text-primary">
              Criar conta
            </Link>
          </div>

          <div className="flex flex-col gap-2">
            <span className="font-medium text-ink">Arenas</span>
            <Link to={ARENA_OWNER_SIGNUP} className="text-ink-secondary hover:text-primary">
              Cadastrar minha arena
            </Link>
            <Link to={ROUTES.LOGIN} className="text-ink-secondary hover:text-primary">
              Entrar
            </Link>
          </div>
        </div>
      </div>

      <div className="border-t border-border/60 px-4 py-4 text-center text-xs text-ink-secondary">
        © {new Date().getFullYear()} Marcô. Projeto de demonstração — dados fictícios.
      </div>
    </footer>
  );
}
